module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageArticleList":{"breadcrumbs":{"index":"Články"},"empty":"Pro tuto kategorii zatím obsah připravujeme. Určitě ale najdete jiné zajímavé články v jiných kategoriích.","heading":"Články","seo":{"description":"Inspirativní články na e-shopu {website}","keywords":"Inspirativní články, {website}","title":"Inspirativní články"}}}}')
  delete Component.options._Ctor
}
